import { Trash2 } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgDelete = mkIcon(Trash2);